import { useSearchParams } from 'react-router-dom';
import api from '../api';

export default function PaymentCancel() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  const handlePaymentAction = async () => {
    try {

      const response = await api.get(`/payment/status/${sessionId}`);
      const result = await response.data; 

      // Send payment status to Flutter
      if (window.PaymentChannel) {
        window.PaymentChannel.postMessage(
          JSON.stringify({
            action: "PAYMENT_STATUS",
            status: result.status
          })
        );
      }
    } catch (error) {
      console.error("Payment status error:", error);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.iconWrap}>
          <span style={s.icon}>✕</span>
        </div>
        <h2 style={s.title}>Payment Cancelled</h2>
        <p style={s.sub}>
          Your payment was not completed. No charges have been made.<br />
          You can try again whenever you're ready.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          {/* <button style={s.secondaryBtn} onClick={() => navigate(-1)}>← Go Back</button> */}
          <button style={s.btn} onClick={() => handlePaymentAction()}>Back to Home</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:        { minHeight: '100vh', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, fontFamily: "'Segoe UI', sans-serif" },
  card:        { background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: '48px 36px', width: '100%', maxWidth: 420, textAlign: 'center' },
  iconWrap:    { display: 'flex', justifyContent: 'center', marginBottom: 16 },
  icon:        { width: 64, height: 64, borderRadius: '50%', background: '#fee2e2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700 },
  title:       { fontSize: 22, fontWeight: 700, color: '#111827', margin: '0 0 12px' },
  sub:         { fontSize: 14, color: '#6b7280', marginBottom: 28, lineHeight: 1.6 },
  btn:         { padding: '11px 28px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  secondaryBtn:{ padding: '11px 28px', background: '#f1f5f9', color: '#4a5568', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer' },
};
